import React from 'react';
import { Tooltip } from 'antd';
import { primaryShades } from '../../../theme/theme';

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;

/**
 * CustomTooltip - Un componente wrapper personalizzato per Tooltip di Ant Design
 * 
 * @param {ReactNode} children - L'elemento che trigger il tooltip quando viene passato sopra
 * @param {string|ReactNode} title - Il contenuto da mostrare nel tooltip
 * @param {string} placement - La posizione del tooltip rispetto all'elemento (top, left, right, bottom, etc.)
 * @param {object} rest - Proprietà aggiuntive da passare al componente Tooltip
 * @returns {JSX.Element} - Componente Tooltip con stile personalizzato
 */

const CustomTooltip = ({
    children,
    title,
    placement = 'top',
    ...rest
}) => {
    return (
        <Tooltip
            title={title}
            placement={placement}
            color={PRIMARY_700}
            {...rest}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip; 